/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArcheryArrow = createReactComponent("outline", "archery-arrow", "IconArcheryArrow", [["path", { "d": "M14 7v3h3l3 -3h-3v-3z", "key": "svg-0" }], ["path", { "d": "M14 10l-9 9", "key": "svg-1" }], ["path", { "d": "M5 15v4h4", "key": "svg-2" }]]);

export { IconArcheryArrow as default };
//# sourceMappingURL=IconArcheryArrow.mjs.map
